import { Memo }   from "../../planner_base";
import { CellPosition }  from "../model";
import watch from "redux-watch";
import isEqual from 'is-equal';
class MemoTag extends Memo {
  init(){
    super.init();
    this.watch();
  }
}
riot.mixin('orders.planner.schedules.memo', MemoTag as riot.TagMixin)
